import { Skeleton } from '@/components/ui/skeleton';

export function BookRecommendationCardSkeleton() {
  return (
    <div className="space-y-3 flex flex-col h-full">
      {/* Cover */}
      <Skeleton className="aspect-[2/3] w-full rounded-lg" />
      
      {/* Title */}
      <Skeleton className="h-4 w-full" />
      
      {/* Author */}
      <Skeleton className="h-3 w-3/4" />
      
      {/* Buttons */}
      <div className="mt-auto space-y-2 pt-2">
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
        <Skeleton className="h-8 w-full" />
      </div>
    </div>
  );
}
